import { Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { UserInfo } from '@omnea-app/fe-rich-text/UserInfo'
import { formatMentionedUserName } from '../formatMentionedUserName'
import { CSS_CLASSES } from './constants'

interface UserMentionProps {
  mentionedUser?: {
    id: string
    userId: string | null
    user: {
      firstName: string
      lastName: string
      email: string
      isOutOfOffice: boolean
    } | null
  }
  showMoreInfoTooltip?: boolean
  fallbackText?: string
}

export const UserMention = ({ mentionedUser, showMoreInfoTooltip = false, fallbackText = '' }: UserMentionProps) => {
  const { t } = useTranslation('requests')

  // If the mentioned user is not found or does not have a user object
  if (!mentionedUser?.user) {
    return <span className={CSS_CLASSES.COMMENT_MENTION}>{fallbackText}</span>
  }

  const mentionedUserFormattedName = formatMentionedUserName(mentionedUser?.user?.firstName, mentionedUser?.user?.lastName)
  const mentionedUserIsOutOfOffice = mentionedUser?.user?.isOutOfOffice
  const mentionedUserString = `${mentionedUserFormattedName}${mentionedUserIsOutOfOffice ? ` [${t('user-tooltip-info.out-of-office')}]` : ''}`

  // If tooltip is disabled, return simple span
  if (showMoreInfoTooltip === false) {
    return <span className={CSS_CLASSES.COMMENT_MENTION}>{mentionedUserString}</span>
  }

  // Return with tooltip
  return (
    <Tooltip
      title={
        <UserInfo
          name={`${mentionedUser?.user.firstName} ${mentionedUser?.user.lastName}`}
          isOutOfOffice={mentionedUser?.user.isOutOfOffice}
          email={mentionedUser?.user.email}
        />
      }
      placement="top-start"
      slotProps={{
        popper: {
          modifiers: [{ name: 'offset', options: { offset: [0, -10] } }],
        },
      }}
    >
      <span className={CSS_CLASSES.COMMENT_MENTION}>{mentionedUserString}</span>
    </Tooltip>
  )
}
